<div class="flex flex-column justify-content-center gap-3">
  @for (communication of communications; track communication) {
    <div class="flex flex-row gap-5 justify-content-between border-round border-300 border-2 px-2">
      <p>{{ communication.system }}</p>
      <p-inputSwitch class="mt-3" [(ngModel)]="communication.enabled" />
    </div>
  }

  <div class="flex flex-row justify-content-center mt-4 gap-3">
    <p-button class="secondary-button" outlined="true" label="Cancelar" (click)="closeDialog()" />

    <p-button class="primary-button" label="Guardar" (click)="saveCommunications()" />
  </div>
</div>
